import * as Yup from "yup";
import React from "react";

export const APIResMessages = {
  S_W_R: "something went wrong",
};
export const CharacterLength = {
  sevenFive: 75,
  twoFiveSix: 256,
  fifty: 50,
  fiveHundred: 500,
  oneTwoFive: 125,
  hundred: 100,
};

export const phoneValidation = Yup.string()
  .nullable()
  .matches(/^[0-9+ ]*$/, "Phone should contain only numbers, + sign and spaces")
  .test(
    "max-digits",
    "Phone should not be more than 10 digits",
    (value) => !value || value.replace(/[^0-9]/g, "").length <= 10,
  );

export const handlePhoneKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
  if (
    !/[0-9+ ]/.test(e.key) &&
    !["Backspace", "Delete", "Tab", "ArrowLeft", "ArrowRight", "Home", "End"].includes(e.key) &&
    !(e.ctrlKey || e.metaKey)
  ) {
    e.preventDefault();
  }
};

export const handlePhoneChange = (
  e: React.ChangeEvent<HTMLInputElement>,
  handleChange: any,
) => {
  const cleaned = e.target.value.replace(/[^0-9+ ]/g, "");
  const digits = cleaned.replace(/[^0-9]/g, "");
  if (digits.length <= 10) {
    e.target.value = cleaned;
    handleChange(e);
  }
};
